import axiosInstance from "../api/authAPI";
import { PermissionApiResponse } from "../types/roleTypes";

export const fetchPermissionList = async (): Promise<PermissionApiResponse> => {
  try {
    const response = await axiosInstance.get("/permissions");
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: "Failed to fetch permissions" };
  }
};
